let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("koyet")).then(() => parcelRequire('2p63w'));